/**
 * @generated SignedSource<<42522a297cb5f0dcb9d35045e872602f>>
 * @relayHash 9305dd39ff73e733f8870a7151de0b89
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 80d93ce7434737b50c4bc4a591f5ac8166e9f40e998c773cb4ca3af6aae61ed5

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useUpdateContentPropertyBlogDeleteMutation$variables = {
  blogPostId: string;
  propertyKey: string;
};
export type useUpdateContentPropertyBlogDeleteMutation$data = {
  readonly confluence: {
    readonly deleteBlogPostProperty: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useUpdateContentPropertyBlogDeleteMutation = {
  response: useUpdateContentPropertyBlogDeleteMutation$data;
  variables: useUpdateContentPropertyBlogDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blogPostId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyKey"
},
v2 = [
  {
    "concreteType": "ConfluenceMutationApi",
    "kind": "LinkedField",
    "name": "confluence",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "blogPostId",
                "variableName": "blogPostId"
              },
              {
                "kind": "Variable",
                "name": "key",
                "variableName": "propertyKey"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "ConfluenceDeleteBlogPostPropertyPayload",
        "kind": "LinkedField",
        "name": "deleteBlogPostProperty",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useUpdateContentPropertyBlogDeleteMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUpdateContentPropertyBlogDeleteMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "9305dd39ff73e733f8870a7151de0b89",
    "id": "80d93ce7434737b50c4bc4a591f5ac8166e9f40e998c773cb4ca3af6aae61ed5",
    "metadata": {},
    "name": "useUpdateContentPropertyBlogDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateContentPropertyBlogDeleteMutation($propertyKey:String!,$blogPostId:ID!){confluence{deleteBlogPostProperty(input:{key:$propertyKey,blogPostId:$blogPostId}){success,errors{message}}}}"
  }
};
})();

(node as any).hash = "85690b5bc7b6924c103210285cc3431a";

export default node;
